// src/composables/app/calculations.tsx

// Types
type Language = "DE" | "EN";
type TranslationKey = "dayof" | "pickup" | "delivery";

interface Translations {
  DE: Record<TranslationKey, string>;
  EN: Record<TranslationKey, string>;
}

// Constants
const TRANSLATION: Translations = {
  DE: {
    dayof: "Tag der",
    pickup: "Abholung",
    delivery: "Abgabe",
  },
  EN: {
    dayof: "Day of",
    pickup: "pickup",
    delivery: "return",
  },
};

export const DAYS_SHORTCUTS = [
  "so",
  "mo",
  "di",
  "mi",
  "do",
  "fr",
  "sa",
] as const;
export const DAYS_NAMES = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"] as const;

// Functions
export const getDayname = (lang: string): string[] => {
  const translatedNames: string[] = [];

  DAYS_NAMES.forEach((_, index) => {
    const dummyDate = new Date(2001, 0, index);
    translatedNames.push(
      dummyDate.toLocaleDateString(lang, { weekday: "short" }),
    );
  });

  return translatedNames;
};

export const langTranslate = (
  toTranslate: TranslationKey,
  lang: Language,
): string => {
  return TRANSLATION[lang][toTranslate];
};
